// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"d3c3c9df","787":"8f9b870b"}[chunkId] + ".chunk.js";
};